import { getSafe } from "@jslib/shared/utils/getSafe";
import { logger } from "@jslib/shared/utils/logger";

import { type ProgramTheme } from "../types/types";

export const collectThreatMetrixDeviceData = async (
  programTheme: ProgramTheme,
  verificationId: string,
): Promise<void> => {
  if (!getSafe(() => programTheme.threatMetrixEnabled, false)) {
    return;
  }

  const DEFAULT_THREATMETRIX_ORG_ID = "cnl2my47";
  const orgId = programTheme.threatMetrixOrgId || DEFAULT_THREATMETRIX_ORG_ID;

  try {
    const { ThreatMetrix } = await import(/* webpackChunkName: "Tmetrix" */ "./index");
    if (
      ThreatMetrix !== undefined &&
      ThreatMetrix.hasOwnProperty("profile") &&
      typeof ThreatMetrix.profile === "function"
    ) {
      const profilingDomain = "content.sheerid.com";
      ThreatMetrix.profile(profilingDomain, orgId, verificationId);
    }
  } catch (error) {
    logger.error(error, "Failed to collect ThreatMetrix device data");
  }
};
